import { createContext } from "react";
const init = {
  account: "",
  balance: "",
  connectMetamask: () => { },
  disconnectMetamask: () => {},
  getBalance: () => {}
}
export const ConnectMetamaskContext = createContext(init);